


import { useState,useEffect } from "react";
import { BrowserRouter as Router, Route, Routes } from "react-router-dom";

import SessionTimeoutWrapper from "./Components/SessionTimeoutWrapper";
// import ProtectedRoute from "./Components/ProtectedRoute"; 


import Layout from "./Components/Layout";
import HomePage from "./Components/HomePage/HomePage";
import AboutUs from "./Components/HomePage/HomeSections/Aboutus";
import Packages from "./Components/HomePage/HomeSections/Packages";
import ContactUs from "./Components/HomePage/HomeSections/contact";
import PrivacyPolicy from "./Components/HomePage/HomeSections/PrivacyPolicy";
import TermsConditions from "./Components/HomePage/HomeSections/Terms&Conditions";
import Documentation from "./Components/HomePage/HomeSections/Documentation";
import HelpCenter from "./Components/HomePage/HomeSections/HelpCenter";
import ElderChildCare from "./Components/HomePage/HomeSections/Elder&ChildCare";
import NursingPhysiotherapy from "./Components/HomePage/HomeSections/Nursing&Physiotherapy";
import DoctorVisitPickup from "./Components/HomePage/HomeSections/DoctorVisitPickup";
import MedicineDiagnosticDelivery from "./Components/HomePage/HomeSections/MedicineDiagnosticDelivery";
import SocialWellness from "./Components/HomePage/HomeSections/SocialWellness";
import EmergencyCare from "./Components/HomePage/HomeSections/EmergencyCareSupport";
import ServiceScreen from "./Components/HomePage/HomeSections/services";
// Booking screens 

import BookAppointment from "./Components/BookingAppointmentScreens/BookAppointment";
import BookingStatusScreen from "./Components/BookingAppointmentScreens/BookingStatusScreen";
import BookingDetailsPage from "./Components/MedicineOrderScreens/BookingDetails";

// AuthonticationScreens
import Login from "./Components/HomePage/AuthonticationScreens/Login";
import Register from "./Components/HomePage/AuthonticationScreens/Register";
import ForgotPassword from "./Components/HomePage/AuthonticationScreens/ForgotPassword";
import GoogleCallback from  "./Components/HomePage/AuthonticationScreens/GoogleCallback";
// serviceselection screens
import ServiceSelectionScreen from "./Components/ServiceScreens/ServiceSelectionScreen";
import ElderlyChildCareScreen from "./Components/ServiceScreens/ElderlyChildCareScreen";
import NursingPysiotherapyScreen from "./Components/ServiceScreens/NursingPysiotherapy";
import MedicineDiagnosticDeliveryScreen from "./Components/ServiceScreens/MedicineDiagnosticDelivery";
import EmergencyCareSupportScreen from "./Components/ServiceScreens/EmergencyCareSupport";
import DoctorVisitPickupDropScreen from "./Components/ServiceScreens/DoctorVisitPickupDrop";
import SocialWellnesActivitiesScreen from "./Components/ServiceScreens/SocialWellnesActivities";


// payment selection screens
import PaymentMethodSelection from "./Components/PaymentsScreens/SelectPaymentScreen";

// menuitems screens
import MyBookingsScreen from "./Components/HomePage/MenuItemScreens/MyBookings";
import ProfilePage from "./Components/HomePage/MenuItemScreens/ProfilePage";
import MyComplaintsScreen from "./Components/HomePage/MenuItemScreens/MyComplaints";
import CancelledBookingsScreen from "./Components/HomePage/MenuItemScreens/CancelledBookings";

// subscription routes
import ResidentSubscriptionView from "./Components/SubscriptionManagement/ResidentSubscriptionView";
// Medicine delivey screens
import MedicineListScreen from "./Components/MedicineOrderScreens/MedicineListScreen";
import MedicineOrderTypeScreen from "./Components/MedicineOrderScreens/MedicineOrderTypeScreen";
import MedicineDeliveryAddressScreen from "./Components/MedicineOrderScreens/MedicineDeliveryAddressScreen";
import MedicinePaymentScreen from "./Components/MedicineOrderScreens/MedicinePaymentScreen";
import MedicineOrderSuccessScreen from "./Components/MedicineOrderScreens/MedicineOrderSuccessScreen";
import MyOrdersScreen from "./Components/MedicineOrderScreens/MyOrdersScreen";
import OrderDetailsScreen from "./Components/MedicineOrderScreens/OrderDetailsScreen";
import PrescriptionUploadScreen from "./Components/MedicineOrderScreens/PrescriptionUploadScreen";
import PatientDetailsForm from "./Components/MedicineOrderScreens/PatientDetailsForm";
import { registerWebToken } from "./firebase";

// package routes
import MyPackageBookings from "./Components/PackageBookings/packagebooking";
import FeedbackPage from "./Components/HomePage/MenuItemScreens/Feedbackpage";

import NursingPhysiotherapyPage from "./Components/NursingPhysiotheraphy/nursingPhysio";
import MyNurPhyBookingsPage from "./Components/NursingPhysiotheraphy/MyNursingPhybookings";

const DisableHorizontalScroll = () => {
  useEffect(() => {
    // Apply to all pages globally
    document.body.style.overflowX = "hidden";
    document.documentElement.style.overflowX = "hidden";

    // Cleanup function
    return () => {
      document.body.style.overflowX = "auto";
      document.documentElement.style.overflowX = "auto";
    };
  }, []); 
  return null;
};

const App = () => {
  const [user, setUser] = useState(null);
  const  [username,setUsername] =useState()


  useEffect(() => {
    registerWebToken();
  }, []);


  return (
    <>
    <Router> 
    <DisableHorizontalScroll />
       <SessionTimeoutWrapper>
        <Routes>
        <Route element={<Layout username={username} setUsername={setUsername}/>}>
          <Route path="/" element={<HomePage/>} />
          {/* <Route path="/" element={<SignupFlow/>} /> */}
          

          {/* Home page screens */}
          <Route path="/serviceweprovide" element={<ServiceScreen/>}/>
          <Route path="/aboutus" element={<AboutUs/>}/>
          <Route path="/packages" element={<Packages/>}/>
          <Route path="/contactus" element={<ContactUs/>}/>
          <Route path="/privacy-policy" element={<PrivacyPolicy/>}/>
          <Route path="/terms&conditions" element={<TermsConditions/>}/>
          <Route path="/documentation" element={<Documentation/>}/>
          <Route path="/help-center" element={<HelpCenter/>}/>
          <Route path="/elder-childcare" element={<ElderChildCare/>}/>
          <Route path="/nursing-physiotherapy" element={<NursingPhysiotherapy/>}/>
          <Route path="/doctor-visit-pickup" element={<DoctorVisitPickup/>}/>
          <Route path="/medicine-diagnostic-delivery" element={<MedicineDiagnosticDelivery/>}/>
          <Route path="/social-wellness" element={<SocialWellness/>}/>
          <Route path="/emergency-care" element={<EmergencyCare/>}/>
          
           {/* AuthonticationScreens */}
          <Route path="/Login" element={<Login/>}/>
          <Route path="/Register" element={<Register/>}/>
          <Route path="/ForgotPassword" element={<ForgotPassword/>}/>
          <Route path="/google/callback" element={<GoogleCallback setUser={setUser} />} />


          <Route path="/book-appointment" element={<BookAppointment/>}/>
      
          {/* Resident screens */}
          {/* <Route element={<ProtectedRoute />}> */}
            {/* booking screens */}
           
            <Route path="/booking-status" element={<BookingStatusScreen/>}/>

            {/* ServiceSelectionScreen */}
            <Route path="/services" element={<ServiceSelectionScreen/>}/>
            <Route path="/elder-child-care" element={<ElderlyChildCareScreen/>}/>
            <Route path="/nursingPhysiotherapy" element={<NursingPysiotherapyScreen/>}/>
            <Route path="/medicine-diagnostic" element={<MedicineDiagnosticDeliveryScreen/>}/>
            <Route path="/emergencycare" element={<EmergencyCareSupportScreen/>}/>
            <Route path="/doctor-visit" element={<DoctorVisitPickupDropScreen/>}/>
            <Route path="/social-wellness-activities" element={<SocialWellnesActivitiesScreen/>}/>

            {/* payment selection screens */}
            <Route path="/select-payment-method" element={<PaymentMethodSelection/>}/>

            {/* menuitems screens */}
            <Route path="/my-bookings" element={<MyBookingsScreen/>}/>
            <Route path="/profile-details" element={<ProfilePage setUsername={setUsername}/>}/>
            <Route path="/my-complaints" element={<MyComplaintsScreen/>}/>
            <Route path="/cancelled-bookings" element={<CancelledBookingsScreen/>}/>

            {/* medicine delivery screens */}
            <Route path="/medicine-list" element={<MedicineListScreen/>}/>
            <Route path="/medicine-order-type" element={<MedicineOrderTypeScreen/>}/>
            <Route path="/medicine-delivery-address" element={<MedicineDeliveryAddressScreen/>}/>
            <Route path="/MedicinePayment" element={<MedicinePaymentScreen/>}/>
            <Route path="/medicine-order-success" element={<MedicineOrderSuccessScreen/>}/>
            <Route path="/my-orders" element={<MyOrdersScreen/>}/>
            <Route path="/order-details" element={<OrderDetailsScreen/>}/>
            <Route path="/prescription-upload" element={<PrescriptionUploadScreen/>}/>
            <Route path="/patient-details-form" element={<PatientDetailsForm/>}/>
            <Route path="/my-packagebookings" element={<MyPackageBookings/>}/>
            <Route path="/my-Feedback" element={<FeedbackPage/>}/>
            <Route path="/booking-details/:id" element={<BookingDetailsPage />} />
            <Route path="/subscription-management" element={<ResidentSubscriptionView/>}/>

            <Route path="/NursingPhysioBooking" element={<NursingPhysiotherapyPage/>}/>
            <Route path="/my-NursingPhyservices" element={<MyNurPhyBookingsPage/>}/>
          
          {/* </Route> */}
        </Route>
          </Routes>
        </SessionTimeoutWrapper>
    </Router>





{/* 
<Snackbar
open={!!notification}
autoHideDuration={6000}
message={notification}
onClose={() => setNotification(null)}
/> */}
</>

  );
};

export default App;


